import { menuApi } from "@api";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { RootState } from ".";
import { updateSnackBar } from "./app";

interface IState {
    show: boolean;
    isLoading: boolean;
    dataMenu: Array<IMenu> | null;
}
const initialState: IState = {
    show: false,
    isLoading: false,
    dataMenu: null,
};
interface IMenu {
    dispatch?: any;
}

const businessCardsMenu = {
    id: 14,
    name: "名刺",
    position: 14,
    link: "https://livelet-employee.adamo.tech/business-cards",
    icon: {
        id:	688,
        path: "https://livelet-stage.s3.ap-northeast-3.amazonaws.com/20241016205210-670fa8eadf433-20241016-drinktest.jpg",
        updated_at: "2024-10-16",
    },
};

const scheduleMenu = {
    id: 15,
    name: "スケジュール",
    position: 15,
    link: "https://livelet-employee.adamo.tech/schedule",
    icon: {
        id: 689,
        path: "https://livelet-stage.s3.ap-northeast-3.amazonaws.com/schedule-icon.png",
        updated_at: "2025-05-29",
    },
};

const facilitiesMenu = {
    id: 16,
    name: "施設予約",
    position: 16,
    link: "https://livelet-employee.adamo.tech/facilities",
    icon: {
        id: 690,
        path: "https://livelet-stage.s3.ap-northeast-3.amazonaws.com/facilities-icon.png",
        updated_at: "2025-05-29",
    },
};
        

export const getMenus = createAsyncThunk("menu/get-menu", async (params: IMenu) => {
    try {
        const res = await menuApi.getMenus();
        //res.data.data.menus.push(businessCardsMenu);
        //res.data.data.menus.push(scheduleMenu);
        //res.data.data.menus.push(facilitiesMenu);
        //console.log(res.data.data);
        return res.data.data;
    } catch (err: any) {
        params.dispatch(
            updateSnackBar({
                messageType: "error",
                message: err.response.data.message,
            })
        );
        return err;
    }
});

const menuSlice = createSlice({
    name: "menu",
    initialState: initialState,

    reducers: {
        setMenu: (state) => {
            state.show = true;
        },
        resetMenu: (state) => {
            state.show = false;
        },
    },
    extraReducers: (builder) => {
        // change password
        builder.addCase(getMenus.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getMenus.fulfilled, (state, action: { payload: any }) => {
            state.isLoading = false;
            state.dataMenu = action.payload.menus;
        });
        builder.addCase(getMenus.rejected, (state) => {
            state.isLoading = false;
        });
    },
});

export const selectMenu = (state: RootState) => state.menu;
export const { setMenu, resetMenu } = menuSlice.actions;
export default menuSlice.reducer;
